<template>
  <a-modal
    :title="title"
    v-model="modalShow"
    width="1100px"
    :footer="null"
    @cancel="close"
    destroyOnClose>
    <a-spin :spinning="spinning">
      <iframe style="width:100%;height:75vh;border:none;" :src="pdfUrl"></iframe>
    </a-spin>
  </a-modal>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      fileData:undefined,
      spinning:false,
      title: "凭证信息",
      modalShow: false,
      expdId:undefined,
      pdfUrl: undefined,
    };
  },
  computed: {},
  methods: {
    open({type,expdId}){
      this.modalShow = true;
      this.expdId = expdId;
      this.pdfUrl = `${process.env.VUE_APP_BASE_API}/file/prePdf?type=${type}&expdId=${this.expdId}` ;
    },
    close(){
      this.modalShow = false;
    },
 
  },
  created() {},
  mounted() {},
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/gold-page/pdf-view.vue